import React from 'react';
import '../App.css';

function About() {
  return (
    <section id="about" className="py-3">
      <div className="container">
        <div className="section-header text-center mb-3">
          <h2 className="section-title">About College</h2>
        </div>
        
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="about-image-container">
              <img 
                src={process.env.PUBLIC_URL + '/assets/college.jpg'} 
                alt="College Campus" 
                className="img-fluid rounded-4 shadow-lg"
              />
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="about-content ps-lg-5">
              <h5 className="mb-4">BMS Institute of Technology and Management</h5>
              <p className="lead">
                BMS Institute of Technology and Management (BMSIT&M) is a private engineering college in Bangalore, established in 2002 by the BMS Educational Trust. It is affiliated with Visvesvaraya Technological University (VTU) and offers both undergraduate and postgraduate programs.
              </p>
              <h5 className="mb-4">MCA Department</h5>
              <p>
               The Master of Computer Applications (MCA) program at BMS Institute of Technology and Management (BMSIT), Bangalore, is a two-year full-time postgraduate course affiliated with Visvesvaraya Technological University. It was established in 2003, has an intake of 120 students as of the 2023-24 academic year. The Department is accredited by NBA twice.
              </p>
              <p className="mb-4">
                The Department has obtained 13 ranks at VTU level since inception. Placement training is offered by corporate trainers in every semester to ensure better employability and more opportunities for the aspirants.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
